import React, {Component} from 'react';
import {Col, Row} from 'react-bootstrap';

class IENotSupported extends Component {

  render() {
    return (
      <Row className="header">
        <Col md={10} mdOffset={1}>
          <h1 className="header-title text-center">{this.props.school} Loss of Privileges List</h1>
          <h4 className="text-center">Internet Explorer is not supported</h4>
          <h4 className="text-center">Please use Chrome or Firefox for best results</h4>
        </Col>
      </Row>
    )
  }

}

export default IENotSupported



// WEBPACK FOOTER //
// ./src/views/IENotSupported.js